export default __webpack_public_path__ + "static/media/icon-bid.40fe648f.svg";